import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap';
import { database } from '../Firebase/firebase';
import { firebaseCollections } from '../Constants/Variables';

import '../Styles/Components/TopInfluencersCard.scss';

export default function TopInfluencersCard() {

    const [finishedLoading, setFinishedLoading] = useState(false)
    const [topPoster, setSetTopPoster] = useState(null)
    const [mostLikeable, setSetMostLikeable] = useState(null)
    const [mostActionable, setSetMostActionable] = useState(null)


    useEffect(() => {

        var d = new Date();
        var from = d.setTime(d.getTime() - (7 * 24 * 60 * 60 * 1000));
        var today = new Date().getTime();

        database.collection(firebaseCollections.thewall).where("timestamp", ">=", new Date(from)).where("timestamp", "<=", new Date(today)).get()
            .then(function (querySnapshot) {
                var postsArr = [];
                querySnapshot.forEach(function (doc) {
                    postsArr.push(doc.data());
                });
                postsArr.sort((a, b) => b.timestamp - a.timestamp);
                // console.log("postsArr: ", postsArr);
                setSetTopPoster(getTopPoster(postsArr));
                setSetMostLikeable(getMostLikeable(postsArr));
                setSetMostActionable(getMostActionable(postsArr));
                setFinishedLoading(true);
            })
            .catch(function (error) {
                console.log("Error getting documents: ", error);
            });

        return () => {
        }
    }, [])


    const getTopPoster = (posts) => {
        var duplicatesArr = [];
        posts.forEach(post => {
            var userDupObj = duplicatesArr.filter((user) => {
                return user.name === post.user.name;
            })

            if (userDupObj.length) {
                userDupObj[0].weeklyPostCount += 1;
            } else {
                post.user.weeklyPostCount = 1;
                duplicatesArr.push(post.user);
            }
        });

        var max = duplicatesArr[0];
        duplicatesArr.forEach(user => {
            if (user.weeklyPostCount > max.weeklyPostCount) {
                max = user;
            }
        });
        return max;
    }

    const getMostLikeable = (posts) => {
        var duplicatesArr = [];
        posts.forEach(post => {
            var userDupObj = duplicatesArr.filter((user) => {
                return user.name === post.user.name;
            })

            if (userDupObj.length) {
                userDupObj[0].weeklyLikesCount += post.likes.length;
            } else {
                post.user.weeklyLikesCount = post.likes.length;
                duplicatesArr.push(post.user);
            }
        });

        var max = duplicatesArr[0];
        duplicatesArr.forEach(user => {
            if (user.weeklyLikesCount > max.weeklyLikesCount) {
                max = user;
            }
        });
        return max;
    }

    const getMostActionable = (posts) => {
        var duplicatesArr = [];
        posts.forEach(post => {
            var userDupObj = duplicatesArr.filter((user) => {
                return user.name === post.user.name;
            })

            if (post.asana) {
                if (userDupObj.length) {
                    userDupObj[0].weeklyActionItemsCount += 1;
                } else {
                    post.user.weeklyActionItemsCount = 1;
                    duplicatesArr.push(post.user);
                }
            }

        });

        var max = duplicatesArr[0];
        duplicatesArr.forEach(user => {
            if (user.weeklyActionItemsCount > max.weeklyActionItemsCount) {
                max = user;
            }
        });
        return max;
    }

    return (
        <div className="TopInfluencersCard">
            <div className="TopInfluencersCard--Header">
                <p className="TopInfluencersCard--Header--Title">Weekly Top Influencers</p>
            </div>
            {
                finishedLoading ?
                    <div className="TopInfluencersCard--Body">
                        {
                            topPoster && topPoster.weeklyPostCount?
                                <div className="TopInfluencersCard--Section">
                                    <p className="TopInfluencersCard--Section--Name">{topPoster.name}</p>
                                    <p className="TopInfluencersCard--Section--Data">{topPoster.weeklyPostCount} Posts</p>
                                    <img src="/images/comment_active_icon.png" alt="" />
                                </div> :
                                <div className="TopInfluencersCard--Section">
                                    <p className="TopInfluencersCard--Section--Name EmptyState">No posters this week</p>
                                    <img src="/images/comment_active_icon.png" alt="" />
                                </div>
                        }

                        {
                            mostLikeable && mostLikeable.weeklyLikesCount ?
                                <div className="TopInfluencersCard--Section">
                                    <p className="TopInfluencersCard--Section--Name">{mostLikeable.name}</p>
                                    <p className="TopInfluencersCard--Section--Data">{mostLikeable.weeklyLikesCount} Likes</p>
                                    <img src="/images/like_active_icon.png" alt="" />
                                </div> :
                                <div className="TopInfluencersCard--Section">
                                    <p className="TopInfluencersCard--Section--Name EmptyState">No love to share this week</p>
                                    <img src="/images/like_active_icon.png" alt="" />
                                </div>
                        }

                        {
                            mostActionable && mostActionable.weeklyActionItemsCount ?
                                <div className="TopInfluencersCard--Section">
                                    <p className="TopInfluencersCard--Section--Name">{mostActionable.name}</p>
                                    <p className="TopInfluencersCard--Section--Data">{mostActionable.weeklyActionItemsCount} Action Items</p>
                                    <div className="TopInfluencersCard--Status-Circle"></div>
                                </div> :
                                <div className="TopInfluencersCard--Section">
                                    <p className="TopInfluencersCard--Section--Name EmptyState">No actions taken this week</p>
                                    <div className="TopInfluencersCard--Status-Circle"></div>
                                </div>
                        }

                    </div> :
                    <div className="TopInfluencersCard--Body">
                        <div className="TopInfluencersCard--Spinner">
                            <Spinner
                                as="span"
                                animation="grow"
                                role="status"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
            }

        </div>
    )
}
